import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { slideshowStyles as styles } from "@insite/content-library/Widgets/Basic/Slideshow";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.dotsContainerWrapper = {
    ...styles.dotsContainerWrapper,
    css: css`
        ${styles.dotsContainerWrapper?.css}
        margin-top: -50px;

        && {
            justify-content: center;
            padding: 0 80px;
            gap: 16px;
        }
    `,
};

styles.dotButton = {
    ...styles.dotButton,
    css: css`
        ${styles.dotButton?.css}

        && {
            border-radius: 50%;
            height: 8px;
            width: 8px;
            min-height: auto;
            padding: 0;
            margin: 0;
        }

        &:active,
        &:hover,
        &:focus {
            background-color: ${getColor(colorStrings.commonGlobalWhite)};
            padding: 0;
        }
    `,
};